import type { AccessEligibilityResult } from "@/api/generated/models";

export const ACCESS_INELIGIBLE_REASONS = {
  "not-eligible-not-medicare":
    "Medicare could not confirm that you have qualifying coverage. This may mean you are not enrolled in Medicare Parts A and B or Medicare is not your primary insurance.",
  "not-eligible-services":
    "you are receiving services that exclude you from ACCESS, such as hospice care, dialysis for end-stage kidney disease, or care through PACE.",
  "not-eligible-diagnoses":
    "Medicare did not find a treating diagnosis that qualifies you for this track.",
  "not-eligible-control-group":
    "you were randomly placed in a comparison group. This has nothing to do with your clinical eligibility and does not affect your Medicare coverage. You can try to enroll again in 12 months. If you have questions, call 1-800-MEDICARE.",
  "not-eligible-already-aligned":
    "you joined another provider for this ACCESS track within the past 90 days. You can only be enrolled with one provider in each track at a time.",
  "not-eligible-clinical-exclusion":
    "Medicare's clinical eligibility rules exclude you from this program.",
  "not-eligible-mismatch":
    "the information submitted for this check did not match Medicare's records. Check your Medicare number and personal details before trying again.",
} as const satisfies Partial<Record<AccessEligibilityResult, string>>;

export type AccessIneligibleCode = keyof typeof ACCESS_INELIGIBLE_REASONS;

export const accessIneligibleMessage = (
  code: AccessEligibilityResult | undefined,
  programName: string,
): string => {
  const reason = code
    ? ACCESS_INELIGIBLE_REASONS[code as AccessIneligibleCode]
    : undefined;
  if (!reason) {
    return `We couldn't confirm your eligibility for the ${programName} program. Please try again later.`;
  }
  if (code === "not-eligible-control-group") {
    return `You can't enroll in the ${programName} program right now because ${reason}`;
  }
  return `You are not eligible for the ${programName} program right now because ${reason}`;
};
